module.exports = __webpack_public_path__ + "static/media/contact-email.76f42abe.svg";